import Component from '../../lib/component'

export default class PanolensComponent extends Component {
    static selector () {
        return '.panolens'
    }

    constructor (opts) {
        super(opts)

        if (!this.getPanolensViewerEl()
                || !this.props.videoUrl)
            return this.el
                .setAttribute('data-rendered', false)

        this.PanolensViewer = new window.PANOLENS.Viewer({
            container: this.getPanolensViewerEl(),
            controlButtons: this.isFullScreen()
                ? ['video']
                : ['fullscreen', 'video']
        })

        this.PanolensPano = new window.PANOLENS
            .VideoPanorama(this.props.videoUrl, {
                muted: true,
                loop: true
            })

        this.listen()

        this.PanolensViewer
            .add(this.PanolensPano)
    }

    listen () {
        this.PanolensPano
            .addEventListener('load', this.onLoad.bind(this), false)
    }

    getPanolensViewerEl () {
        return this.el.querySelector('#panolens-viewer')
    }

    isFullScreen () {
        return Boolean(this.el.querySelector('.panolens-viewer-fullscreen'))
    }

    onError () {
        const panolensErrorEl = this.el
            .querySelector('.panolens-error')

        if (panolensErrorEl)
            panolensErrorEl
                .classList.remove('display-none')

        if (this.PanolensViewerEl)
            this.getPanolensViewerEl
                .classList.add('display-none')
    }

    onLoad (e) {
        if (!e.target.videoElement)
            return this.onError()

        this.PanolensPano
            .removeEventListener('load', this.onLoad, false)

        e.target.videoElement.onerror = this.onError

        e.target.videoElement.oncanplay = setTimeout(() => {
            if (this.getPanolensViewerEl())
                this.getPanolensViewerEl()
                    .classList.add('loaded')

            e.target.playVideo()
        }, 200)
    }
}
